import React, { useState } from "react";

const HeaderContainer = ({ Owl, HeaderBuilder }) => {
    [Owl.header, Owl.setHeader] = useState({});
    return <HeaderBuilder header={Owl.header} set={Owl.set} />;
};

export default HeaderContainer;
